import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { LineChart, Line, BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

const COLORS = ["#4F46E5","#06B6D4","#8B5CF6","#10B981","#F59E0B","#EF4444"];

export default function AdminAnalytics() {
  const [a, setA] = useState({});
  useEffect(() => { api.get("/admin/analytics").then(r => setA(r.data)); }, []);

  const chartCommon = { className: "" };

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14">
      <span className="px-2 py-1 rounded-md bg-red-500/20 border border-red-500/40 text-red-300 text-[10px] tracking-widest uppercase">ADMIN</span>
      <h1 className="mt-2 text-3xl font-bold tracking-tight" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>Analytics</h1>

      <div className="mt-8 grid md:grid-cols-2 gap-6">
        <div className="glass-strong rounded-2xl p-5">
          <h3 className="text-sm uppercase tracking-widest text-zinc-400">New Users</h3>
          <div className="h-60 mt-3">
            <ResponsiveContainer><LineChart data={a.newUsers || []}><CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)"/><XAxis dataKey="date" stroke="#71717A" fontSize={10}/><YAxis stroke="#71717A" fontSize={10}/><Tooltip contentStyle={{background:"#111",border:"1px solid #333"}}/><Line type="monotone" dataKey="value" stroke="#4F46E5" strokeWidth={2}/></LineChart></ResponsiveContainer>
          </div>
        </div>
        <div className="glass-strong rounded-2xl p-5">
          <h3 className="text-sm uppercase tracking-widest text-zinc-400">Revenue (ZAR)</h3>
          <div className="h-60 mt-3">
            <ResponsiveContainer><BarChart data={a.revenue || []}><CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)"/><XAxis dataKey="date" stroke="#71717A" fontSize={10}/><YAxis stroke="#71717A" fontSize={10}/><Tooltip contentStyle={{background:"#111",border:"1px solid #333"}}/><Bar dataKey="value" fill="#10B981"/></BarChart></ResponsiveContainer>
          </div>
        </div>
        <div className="glass-strong rounded-2xl p-5">
          <h3 className="text-sm uppercase tracking-widest text-zinc-400">Documents per day</h3>
          <div className="h-60 mt-3">
            <ResponsiveContainer><LineChart data={a.documents || []}><CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)"/><XAxis dataKey="date" stroke="#71717A" fontSize={10}/><YAxis stroke="#71717A" fontSize={10}/><Tooltip contentStyle={{background:"#111",border:"1px solid #333"}}/><Line type="monotone" dataKey="value" stroke="#06B6D4" strokeWidth={2}/></LineChart></ResponsiveContainer>
          </div>
        </div>
        <div className="glass-strong rounded-2xl p-5">
          <h3 className="text-sm uppercase tracking-widest text-zinc-400">Plan distribution</h3>
          <div className="h-60 mt-3">
            <ResponsiveContainer>
              <PieChart>
                <Pie data={a.planDistribution || []} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={70} label>
                  {(a.planDistribution || []).map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]}/>)}
                </Pie>
                <Tooltip contentStyle={{background:"#111",border:"1px solid #333"}}/>
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      <div className="mt-6 grid md:grid-cols-2 gap-6">
        <div className="glass-strong rounded-2xl p-5">
          <h3 className="text-sm uppercase tracking-widest text-zinc-400">File types</h3>
          <div className="h-52 mt-3">
            <ResponsiveContainer><BarChart data={a.fileTypes || []}><CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)"/><XAxis dataKey="name" stroke="#71717A" fontSize={10}/><YAxis stroke="#71717A" fontSize={10}/><Tooltip contentStyle={{background:"#111",border:"1px solid #333"}}/><Bar dataKey="value" fill="#8B5CF6"/></BarChart></ResponsiveContainer>
          </div>
        </div>
        <div className="glass-strong rounded-2xl p-5 flex flex-col justify-center">
          <div className="text-xs uppercase tracking-widest text-zinc-400">Avg rounds to 0% AI</div>
          <div className="mt-2 text-5xl font-bold" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>{a.avgRounds || 0}</div>
        </div>
      </div>
    </div>
  );
}
